import {
  usePortfolioModelEnabledPortfolioGroupsListQuery,
  usePortfolioPortfolioGroupListQuery,
} from "@app/api/carApi.generated";
import { refetchOnFocus } from "@app/const";
import { useSimulationGroups } from "../useSimulationGroups";
import { useNavigate } from "react-router-dom";
import { assetAllocationPages } from "@app/const/route.const";

export const usePortfolioGroupList = ({
  isProviderModels,
}: {
  isProviderModels: boolean;
}) => {
  const simulationGroups = useSimulationGroups();

  const providerModels = usePortfolioModelEnabledPortfolioGroupsListQuery(
    undefined,
    {
      refetchOnFocus,
      skip: !isProviderModels,
    },
  );

  const myModels = usePortfolioPortfolioGroupListQuery(undefined, {
    refetchOnFocus,
    skip: isProviderModels,
  });

  const portfolioGroups = isProviderModels ? providerModels : myModels;

  const navigate = useNavigate();

  const items = Array.from(portfolioGroups.data ?? [])
    .sort((a, b) => {
      const aActive = a.is_active ? 1 : 0;
      const bActive = b.is_active ? 1 : 0;
      return (
        bActive - aActive ||
        (b.created_at ?? "").localeCompare(a.created_at ?? "")
      );
    })
    .filter((i) => !i.is_single_portfolio_module)
    .map((i) => ({
      ...i,
      title: `${i.title}${simulationGroups.getSimulationSuffix(
        i.simulation_group,
      )}`,
    }));

  const gotoPortfolioGroup = (portfolioGroupId: string) => {
    const versions =
      items.find((i) => i.id === portfolioGroupId)?.versions ?? [];

    navigate(
      assetAllocationPages.getEditPortfolioGroupUrl({
        portfolioGroupId,
        isPublished: versions.length > 1,
      }),
    );
  };

  return {
    items,
    isLoading: simulationGroups.isLoading || portfolioGroups.isLoading,
    gotoPortfolioGroup,
  };
};

export type UsePortfolioGroupList = ReturnType<typeof usePortfolioGroupList>;
